// components
import { LogPanel } from './LogPanel';

// types
import {
  ContextPanelMenuItem,
  ContextPanelNavigationItemType
} from './ContextPanel.types';

// utils
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common', 'mrp.contextPanel');

export const ContextPanelMenuItems: ContextPanelMenuItem[] = [
  {
    id: ContextPanelNavigationItemType.TASK_LIST,
    icon: 'list-check',
    label: t('taskList')
  },
  {
    id: ContextPanelNavigationItemType.WAITING_LIST,
    icon: 'people-group',
    label: t('waitingList')
  },
  {
    id: ContextPanelNavigationItemType.LOG,
    icon: 'book',
    component: <LogPanel />,
    label: t('history')
  }
];
